import * as React from "react";
import { CircleCheckIcon, CalendarIcon } from "lucide-react";
import { URLS, useSocialCoachSession } from "@/utils";
import { Link } from "react-router-dom";
import { usePostFlowContext } from "../SharedPostFlowContext";

export function SuccessStep() {
  const { isPlayer } = useSocialCoachSession();
  const { deliveryOptions } = usePostFlowContext();
  const { isAutoPost, sendMode } = deliveryOptions;
  const isScheduled = sendMode === "SCHEDULED";

  const getStatusConfig = () => {
    if (isScheduled) {
      return {
        title: "Successfully Scheduled",
        description:
          "Your post has been successfully scheduled. We'll handle the delivery at the date and time you specified.",
      };
    }

    if (isAutoPost) {
      return {
        title: "Queued for Publishing",
        description:
          "Your post has been successfully queued for publishing. It will appear on the selected social networks shortly.",
      };
    }

    return {
      title: "Queued for Delivery",
      description: `Your post has been queued for delivery. We're pushing it to your ${
        isPlayer ? "mobile device" : "players' mobile devices"
      } right now.`,
    };
  };

  const { title, description } = getStatusConfig();

  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
      <div className="relative mb-6">
        <div className="absolute inset-0 scale-150 bg-green-100 rounded-full blur-2xl opacity-50" />
        <CircleCheckIcon className="size-16 text-green-600 relative z-10" />
      </div>

      <h3 className="text-2xl font-bold text-foreground mb-2">{title}</h3>

      <p className="text-muted-foreground max-w-sm mb-8 leading-relaxed">{description}</p>

      <div className="w-full max-w-xs bg-slate-50 border border-slate-200 rounded-xl p-4 flex items-start gap-3 text-left mb-8">
        <CalendarIcon className="size-5 text-primary shrink-0 mt-0.5" />
        <div className="flex flex-col gap-1">
          <span className="text font-semibold text-slate-900">Track your posts</span>
          <p className="text-sm text-slate-500 leading-normal">
            You can track the progress and manage your scheduled content from your content calendar.
          </p>
          <Link
            to={isPlayer ? URLS.player.calendar : URLS.coach.calendar}
            className="text-sm font-bold text-primary hover:underline mt-1"
          >
            Go to Calendar →
          </Link>
        </div>
      </div>
    </div>
  );
}
